import axios from 'axios';
import { getLoggedInUserRole, getLoggedInUsername } from '../utils/auth';
import { formatDateLocal } from '../utils/reportDateRange';

export const FETCH_SUMMARY_REPORT_REQUEST = 'FETCH_SUMMARY_REPORT_REQUEST';
export const FETCH_SUMMARY_REPORT_SUCCESS = 'FETCH_SUMMARY_REPORT_SUCCESS';
export const FETCH_SUMMARY_REPORT_FAILURE = 'FETCH_SUMMARY_REPORT_FAILURE';
const base_url  = process.env.REACT_APP_API_URL_ADMIN;

export const getSummaryReport = ({ startDate, endDate, companyId, silent = false }) => async (dispatch) => {
    if (!silent) {
      dispatch({ type: FETCH_SUMMARY_REPORT_REQUEST });
    }
    try {
       const role = getLoggedInUserRole();
       const loggedInUsername = getLoggedInUsername();

      const response = await axios.post(`${base_url}`, {
        apiName: 'reporting',
        command: 'summaryreport',
        startDate: formatDateLocal(startDate),
        endDate: formatDateLocal(endDate),
        company_id: companyId,
        role,
        loggedInUserRole: role,
        loggedInUsername,
      });
      dispatch({
        type: FETCH_SUMMARY_REPORT_SUCCESS,
        payload: response.data.data,
      });
    } catch (error) {
      if (!silent) {
        dispatch({
          type: FETCH_SUMMARY_REPORT_FAILURE,
          payload: error.response?.data?.message || 'Failed to fetch summary report',
        });
      }
    }
  };
